import React, { useState } from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import ButtonUI from '../../../../../../components/UI/ButtonUI';
import { Row, Modal, Button } from 'react-materialize';
import { showMessageToastCustom, translate } from '../../../../../../utils/util';
import * as XLSX from 'xlsx';
import * as FileSaver from 'file-saver';
import LinePickingService from '../../../../../../services/LinePickingService';

const ModalUpload = (props) => {
    const [selectedFile, setSelectedFile] = useState();
    const [messages, setMessages] = useState([]);

    const onCancel = (event) => {
        if (props.onCancel) {
            props.onCancel(event);
        }
        close();
    };

    const close = () => {
        if (props.onClose) {
            setMessages([]);
            props.onClose();
        }
    };

    const send = () => {
        setMessages([])
        props.uploadPartnumbers(selectedFile, (response) => {
            if (response && response.length > 0) {
                clearFileInput()
                setMessages(response || [])
                showMessageToastCustom(translate('info', 'general'), translate('file-successfully', 'general'), 1000, 'mdi mdi-checkbox-marked-circle-outline green-text');
            } else {
                clearFileInput();
                setMessages([])
                showMessageToastCustom(translate('info', 'general'), translate('file-successfully', 'general'), 1000, 'mdi mdi-checkbox-marked-circle-outline green-text');
                props.onConfirm();
                close();
            }
        })
    };

    const clearFileInput = () => {
        document.getElementById("fileInput").value = "";
        setSelectedFile();
    }

    const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.shee;charset=UTF-8';
    const fileExtension = '.xlsx';
    const template = [{
        'DESENHO': "",
        'USO': "",
        'MODELO': ""
    }]

    const exportExcel = () => {

        const ws = XLSX.utils.json_to_sheet(template);
        const wb = { Sheets: { 'data': ws }, SheetNames: ['data'] };
        const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
        const data = new Blob([excelBuffer], { type: fileType });
        FileSaver.saveAs(data, 'Template' + fileExtension);

    }

    return (
        <Modal
            open={props.open}
            options={{ dismissible: false }}
            id={props.id || 'ModalUploadPartnumbers'}
            actions={
                <Row className="center" style={{ height: "60%" }}>
                    <Button onClick={onCancel} className="col s6 btn waves-effect waves-light btn-flat" modal="close" disabled={props.disabledCancel}>
                        {props.btnCancel ? props.btnCancel : translate('cancel', 'general')}
                    </Button>
                    <ButtonUI onClick={send} text={props.btnConfirm ? props.btnConfirm : translate('add', 'general')} />
                </Row>
            }>
            <div>
                {
                    props.open &&
                    <>
                        <Row className="center">
                            <div className="sixth-text-color center">
                                <span className="title col s12">{translate('massiveUpload', 'stock')}</span>
                                <span className="col s12" >{props.content}</span>
                            </div>
                        </Row>
                        <div className="title" style={{ float: 'right', margin: '10px' }}>
                            <i className="mdi mdi-24px mdi-arrow-down-circle" style={{ cursor: 'pointer' }} onClick={() => exportExcel()}></i>
                        </div>
                        <div id="formInput" className='row'>
                            <div className="input-field no-padding col s12">
                                <input
                                    id="fileInput"
                                    required
                                    type="file"
                                    onClick={clearFileInput}
                                    onChange={(event) => setSelectedFile(event.target.files[0])}
                                    accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                                />
                            </div>
                            {messages.length > 0 &&
                                <div className="input-field no-padding col s12">
                                    <div style={{ display: 'flex', flexDirection: 'column', padding: '15px 0px' }}>
                                        <span className="fourth-text-color">
                                            {translate('fileImportCriticism', 'general')}
                                        </span>
                                        {messages.map((item, index) => (
                                            <span key={index} className="fourth-text-color">
                                                {item}
                                            </span>
                                        ))}
                                    </div>
                                </div>
                            }
                        </div>
                    </>
                }
            </div>
        </Modal >
    );
};

const mapStateToProps = (state) => {
    return {
        user: state.userReducer.user,
        sheds: state.configReducer.sheds,
        physicalConfirmation: state.physicalConfirmationReducer.physicalConfirmation,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        uploadPartnumbers: (file, callback) => {
            dispatch(LinePickingService.uploadPartnumbersUseModel(file, callback));
        },
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(ModalUpload));